import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Routes } from './routes';

export const Router: React.FC<{}> = () => (
  <BrowserRouter>
    <Routes />
  </BrowserRouter>
);
